import styled, { css } from 'styled-components'

import { mediaMaxMobile } from '@blade/ui-theme'
import { useBreakpoint } from '@root/shared/hooks/useBreakpoint'

import { AuthModalInfo } from './auth-modal-info'
import { AuthModalHeader } from './mobile/auth-modal-header'

import type { IconProps } from '@root/shared/ui-kit'

type AuthModalProps = {
  children: React.ReactNode
  infoIcon?: React.FC<IconProps>
  infoMessage: React.ReactNode
}

export const AuthModal: React.FC<AuthModalProps> = ({
  children,
  infoIcon,
  infoMessage,
}: AuthModalProps) => {
  const isMobile = useBreakpoint() === 'mobile'
  return (
    <Body>
      {isMobile ? <AuthModalHeader /> : undefined}
      <Content>{children}</Content>
      {isMobile ? undefined : (
        <AuthModalInfo icon={infoIcon}>{infoMessage}</AuthModalInfo>
      )}
    </Body>
  )
}

const Body = styled.div`
  background: rgba(var(--background-1-rgb), 0.6);
  background: var(--appearanceA-6);

  border: 1px solid var(--backgroundA-3);
  box-shadow: 0px 10px 40px 0px var(--appearanceA-4);
  backdrop-filter: blur(50px);

  overflow: hidden;
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  border-radius: 30px;

  min-width: 580px;
  transition: box-shadow 1s ease;

  &:hover {
    box-shadow: 0px 10px 40px 0px var(--appearanceA-6);
  }

  ${mediaMaxMobile(css`
    min-width: 0;
    width: 90vw;
    grid-template-columns: minmax(0, 1fr);
    grid-template-rows: auto minmax(0, 1fr);
    border-radius: 20px;
  `)}
`

const Content = styled.div`
  min-height: 250px;
  display: grid;

  padding-inline: 28px 20px;
  padding-block: 30px 28px;

  ${mediaMaxMobile(css`
    padding-inline: 14px;
    padding-block: 16px 24px;
  `)}
`
